/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Send_StatusInputs */

const en_error_crm_send_status = /** @type {(inputs: Error_Crm_Send_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The send is no longer where this can be done. Reload it.`)
};

/**
* | output |
* | --- |
* | "The send is no longer where this can be done. Reload it." |
*
* @param {Error_Crm_Send_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_send_status = /** @type {((inputs?: Error_Crm_Send_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Send_StatusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_send_status(inputs)
});